module.exports = __webpack_public_path__ + "img/23f.3825f3a1.png";